import './style.less';

export default function($state, $stateParams, $location, ResolveClass, store) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;

  vm.setCollapse = () => {
    vm.collapse = !vm.collapse;
    store.set('mktCollapse', vm.collapse);
  };

  function getCollapse() {
    const storedValue = store.get('mktCollapse');
    return storedValue == null ? ResolveClass.applicationSettings('mkt').collapse : !!storedValue;
  }

  function setTitle(state) {
    if (vm.defaultTitle) return vm.defaultTitle;
    if (state.includes('bundles')) return ResolveClass.applicationSettings('mktBundles').name || 'Bundles';
    if (state.includes('internalCourses'))
      return ResolveClass.applicationSettings('mktInternalTraining').name || 'Internal Webinars & Live Courses';
    if (state.includes('courses')) return ResolveClass.applicationSettings('mktSelfStudy').name || 'Self Study';
    return ResolveClass.applicationSettings('mktEvents').name || 'Webinars & Live Courses';
  }

  function setType(state) {
    if (state.includes('bundles')) return 'bundle';
    if (state.includes('internalCourses')) return 'internal';
    if (state.includes('courses')) return 'selfStudy';
    return 'public';
  }

  function setView(newView) {
    const currentView = newView || vm.defaultView || $stateParams.view || store.get('marketplaceView') || 'table';
    let view = 'table';

    if (currentView === 'calendar' && ['internal', 'public'].includes(vm.type)) {
      view = 'calendar';
    }

    if (currentView === 'card' && ['internal', 'public', 'selfStudy'].includes(vm.type)) {
      view = 'card';
    }

    $location.search('view', view);
    store.set('marketplaceView', view);
    vm.view = view;
  }

  vm.setView = setView;

  function activate() {
    vm.forceShow = !vm.collapseFilters;
    vm.collapse = getCollapse();
    vm.nameSearch = $stateParams.name;
    vm.state = vm.stateOverride || $state.current.name;
    vm.pageTitle = setTitle(vm.state);
    vm.type = setType(vm.state);

    setView();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/marketplace/controller.js